const classNames = (...classes: Array<string>) =>
  classes.filter(Boolean).join(" ");

export default classNames;
